import type { FC } from "react"

export const PlusIcon: FC<{ className?: string; background?: string }> = ({ className, background }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <circle
        cx="11"
        cy="11"
        r="11"
        fill={background || "#F7F7F7"}
      />
      <rect
        x="10"
        y="5"
        width="2"
        height="12"
        rx="1"
        fill="#2F80ED"
      />
      <rect
        x="17"
        y="10"
        width="2"
        height="12"
        rx="1"
        transform="rotate(90 17 10)"
        fill="#2F80ED"
      />
    </svg>
  )
}
